  <div id="carouselExampleControls" class="carousel slide babyface-slide" data-ride="carousel">
    <div class="carousel-inner">
      <div class="carousel-item active">
        <img class="d-block w-100" src="assets/images/banner.png" alt="First slide">
      </div>
    </div>
  </div>
